import { render, staticRenderFns } from "./AdminLhEdit.vue?vue&type=template&id=8fa97c3a&scoped=true"
import script from "./AdminLhEdit.vue?vue&type=script&lang=js"
export * from "./AdminLhEdit.vue?vue&type=script&lang=js"
import style0 from "./AdminLhEdit.vue?vue&type=style&index=0&id=8fa97c3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa97c3a",
  null
  
)

export default component.exports